var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect } from 'react';
import { useMutation } from 'react-query';
import { ticketsService } from 'src/Utils/ticketsService';
import { COMPLETED } from 'src/Utils/constants';
import { SUCCESS_MESSAGES, ERROR_MESSAGES } from 'src/Utils/toastMessages';
import { showSuccessToast, showErrorToast } from 'src/Utils/toastHelper';
import { Card, CardTitle, ServiceTypeLabel, TitleInput, DescriptionTextarea, SaveButtonContainer, SaveButton, } from './styles';
var TicketInformation = function (_a) {
    var ticket = _a.ticket, onTitleChange = _a.onTitleChange, onDescriptionChange = _a.onDescriptionChange, onSave = _a.onSave, _b = _a.isReadOnly, isReadOnly = _b === void 0 ? false : _b;
    var _c = useState({
        title: ticket.title,
        description: ticket.description,
    }), formData = _c[0], setFormData = _c[1];
    var isTicketCompleted = ticket.status === COMPLETED || isReadOnly;
    useEffect(function () {
        setFormData({
            title: ticket.title,
            description: ticket.description,
        });
    }, [ticket.title, ticket.description]);
    var handleInputChange = function (field) { return function (e) {
        if (isTicketCompleted)
            return;
        var newValue = e.target.value;
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = newValue, _a)));
        });
        if (field === 'title') {
            onTitleChange === null || onTitleChange === void 0 ? void 0 : onTitleChange(newValue);
        }
        else {
            onDescriptionChange === null || onDescriptionChange === void 0 ? void 0 : onDescriptionChange(newValue);
        }
    }; };
    var mutateUpdateTicket = useMutation(ticketsService.updateTicket, {
        onSuccess: function () {
            showSuccessToast(SUCCESS_MESSAGES.tickets.updated);
            onSave === null || onSave === void 0 ? void 0 : onSave();
        },
        onError: function (error) {
            console.error('Error updating ticket:', error);
            showErrorToast(error, ERROR_MESSAGES.tickets.update);
        },
    })[0];
    var handleSave = function () {
        if (formData.title === ticket.title &&
            formData.description === ticket.description) {
            return;
        }
        if (isTicketCompleted) {
            showErrorToast(null, ERROR_MESSAGES.tickets.modifyCompleted);
            return;
        }
        mutateUpdateTicket({
            id: ticket.id,
            title: formData.title,
            description: formData.description,
        });
    };
    return (React.createElement(Card, null,
        React.createElement(CardTitle, null, isReadOnly ? 'Información del Reclamo' : 'Información del Ticket'),
        React.createElement("div", null,
            React.createElement(ServiceTypeLabel, null, "Problema o Solicitud"),
            React.createElement(TitleInput, { value: formData.title, onChange: handleInputChange('title'), placeholder: "Ingresa t\u00EDtulo a la solicitud", disabled: isTicketCompleted })),
        React.createElement("div", null,
            React.createElement(ServiceTypeLabel, null, "Descripci\u00F3n del problema"),
            React.createElement(DescriptionTextarea, { value: formData.description, onChange: handleInputChange('description'), placeholder: "Cont\u00E1 que pas\u00F3, d\u00F3nde y c\u00F3mo. Ej.: 'Las luces del hall PB no encienden desde ayer, Torre 1.'", disabled: isTicketCompleted })),
        !isTicketCompleted && (React.createElement(SaveButtonContainer, null,
            React.createElement(SaveButton, { onClick: handleSave }, "Guardar")))));
};
export default TicketInformation;
